import type { RecommendedSolution } from "../types";

export const RECOMMENDED_SOLUTIONS = {
  decision_friction: {
    title: "Decision Friction Map",
    problem_detected: "Abteilungen bewerten denselben Kunden nach unterschiedlichen Logiken.",
    solution_sketch:
      "Die Decision Friction Map macht sichtbar, wo Bewertung, Verantwortung und Priorisierung auseinanderlaufen.",
    why_this_matters:
      "Ohne gemeinsame Entscheidungslogik entstehen Reibung, langsamere Entscheidungen und widersprüchliche Prioritäten.",
    primary_link_label: "Decision Friction Map ansehen",
    primary_link_url: "/de/frameworks/decision-friction-map/",
    recommended_addon_label: "Decision Audit",
    recommended_addon_description: "Ein fokussierter Einstieg, um Entscheidungsreibung sichtbar zu machen.",
    recommended_addon_url: "/de/produkte/decision-audit/",
    addon_availability: "available_on_request"
  },
  customer_value: {
    title: "Customer Value Matrix",
    problem_detected: "Customer-Value-Kriterien sind noch nicht klar genug operationalisiert.",
    solution_sketch:
      "Die Customer Value Matrix übersetzt Abteilungsperspektiven in Kriterien, Gewichtungen und Bewertungslogik.",
    why_this_matters:
      "So wird Kundenwert nicht nur diskutiert, sondern für Sales, Marketing, Finance und Delivery nutzbar.",
    primary_link_label: "Customer Value Matrix ansehen",
    primary_link_url: "/de/frameworks/customer-value-matrix/",
    recommended_addon_label: "Customer Value Calculation",
    recommended_addon_description: "Ein nutzbares Bewertungsmodell für Kunden, Leads und Opportunities.",
    recommended_addon_url: "/de/produkte/hauffe-os-workshop/",
    addon_availability: "included"
  },
  go_to_market: {
    title: "Go-to-Market Logic Map",
    problem_detected: "Zielkunden, Angebot, Positionierung oder Vertriebsprioritäten sind nicht eindeutig genug.",
    solution_sketch:
      "Die Go-to-Market Logic Map verbindet Customer Value mit Zielkundenlogik, Angebot und Vertriebsfokus.",
    why_this_matters:
      "Dadurch werden Marktentscheidungen nicht nur lauter, sondern klarer und fokussierter.",
    primary_link_label: "Go-to-Market Logic Map ansehen",
    primary_link_url: "/de/frameworks/go-to-market-logic-map/",
    recommended_addon_label: "Go-to-Market Strategy Sprint",
    recommended_addon_description: "Ein kompakter Sprint zur Klärung von Zielkunden, Angebot und 90-Tage-Fokus.",
    recommended_addon_url: "/de/produkte/go-to-market-strategy-sprint/",
    addon_availability: "available_on_request"
  },
  execution: {
    title: "HAUFFE Operating Loop",
    problem_detected: "Entscheidungen werden nicht zuverlässig in Umsetzung, Kennzahlen und Verantwortung übersetzt.",
    solution_sketch:
      "Der HAUFFE Operating Loop verbindet Erkennen, Bewerten, Entscheiden, Umsetzen, Messen und Anpassen.",
    why_this_matters:
      "Klarheit wird erst wertvoll, wenn sie in Arbeitsrhythmus und Verantwortlichkeiten ankommt.",
    primary_link_label: "HAUFFE Operating Loop ansehen",
    primary_link_url: "/de/frameworks/hauffe-operating-loop/",
    recommended_addon_label: "Implementation Sprint",
    recommended_addon_description: "Ein Umsetzungsformat, um Decision Clarity in operative Routinen zu bringen.",
    recommended_addon_url: "/de/produkte/implementation-sprint/",
    addon_availability: "available_on_request"
  },
  sales_focus: {
    title: "Sales Decision Clarity Map",
    problem_detected: "Sales-Prioritäten oder Opportunity-Fokus sind nicht klar genug.",
    solution_sketch:
      "Die Sales Decision Clarity Map macht sichtbar, welche Verkaufschancen Wert erzeugen und welche Kapazität binden.",
    why_this_matters:
      "Sales-Fokus entsteht, wenn Wert, Aufwand und strategische Passung gemeinsam bewertet werden.",
    primary_link_label: "Sales Decision Clarity Map ansehen",
    primary_link_url: "/de/frameworks/sales-decision-clarity-map/",
    recommended_addon_label: "Sales Decision Clarity Sparring",
    recommended_addon_description: "Ein fokussiertes Sparring zur Priorisierung von Opportunities und Verkaufschancen.",
    recommended_addon_url: "/de/produkte/sales-decision-clarity-sparring/",
    addon_availability: "digital_addon_planned"
  }
} satisfies Record<string, RecommendedSolution>;

export function getDefaultRecommendedSolution(): RecommendedSolution {
  return RECOMMENDED_SOLUTIONS.customer_value;
}
